import { connect } from 'react-redux';

import { userManagementActions } from "dataflow/billingPortal/actions";

import UserUpdatePresentation from './UserUpdatePresentation';

function mapStateToProps(state) {
    const { 
        getUserGroupPermissionList_requesting, getUserGroupPermissionList_status,
        userGroupPermissionList,

        isUserRecordUpdatedSuccessfully,

        addUser_requesting, updateUser_requesting,

        userPermissions
    } = state.userManagementReducers;
    
	return {
        getUserGroupPermissionList_requesting, getUserGroupPermissionList_status,
        userGroupPermissionList,

        isUserRecordUpdatedSuccessfully,

        addUser_requesting, updateUser_requesting,
        
        userPermissions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateUser: (userInfo, userGroups) => { dispatch(userManagementActions.updateUser(userInfo, userGroups)); },
        addUser: (userInfo, userGroups) => { dispatch(userManagementActions.addUser(userInfo, userGroups)); },
    };
}

const UserUpdate = connect(mapStateToProps, mapDispatchToProps)(UserUpdatePresentation);

export default UserUpdate;